export default __webpack_public_path__ + "static/media/buttons-tp-x.5b113714.svg";